<div
  *ngIf="dropOff && ((invoice.allowStripePayment && !invoice.paidWithStripe) || !invoice.allowStripePayment) && !allReadyBooked">


  <div class="container center-container white-container margin-top-16" *ngIf="dropOff">

    <div class="complete-payment-header" *ngIf="!multiBikeDelivery">
      <div *ngIf="invoice && invoice.allowStripePayment">{{'cyclist.confirm_address_and_payment' | translate}}</div>
      <div *ngIf="invoice && !invoice.allowStripePayment">{{'cyclist.confirm_address' | translate}}</div>
    </div>
    <div class="complete-payment-header" *ngIf="multiBikeDelivery && linkedServices && linkedServices.length > 0">
      <div
        *ngIf="invoice && invoice.allowStripePayment">{{'cyclist.confirm_address_and_payment_multiple' | translate : {linkedServices: (linkedServices.length + 1)} }}</div>
      <div
        *ngIf="invoice && !invoice.allowStripePayment">{{'cyclist.confim_address_mulitple' | translate : {linkedServices: (linkedServices.length + 1)} }}</div>
    </div>

    <div>
      <h6
        [ngClass]="{error:errorAddress}">{{'bikeshop.modal.update_job_card.collections.delivery_address' | translate}}</h6>
      <p-autoComplete [(ngModel)]="address" [suggestions]="addressOptions" (completeMethod)="search($event)"
                      (onSelect)="onSelect($event)" auto-complete='new-password' field="address"></p-autoComplete>
    </div>
    <div *ngIf="addressOutOfRange">
      <div class="address-out-of_range">
        {{'cyclist.address_out_of_range' | translate}}
      </div>
    </div>
    <div *ngIf="!addressOutOfRange && !addressConfirmed && !confirmingAddress"
         [ngClass]="{'disabled': !address || !selectedService || !selectedService.id}">
      <div class="margin-top-16">
        <!-- <p-checkbox [(ngModel)]="confirmAddress" [binary]="true" (onChange)="recalculateDeliveryCost($event)"
          [disabled]="!address || !areaID || !googlePlaceID"></p-checkbox> -->
        <button pButton type="button" (click)="recalculateDeliveryCost($event)" class="accent"
                [disabled]="!address || !areaID || !googlePlaceID || confirmingAddress"
                label="{{'cyclist.submit' | translate }}"></button>
      </div>
      <!-- <span>Please confirm that the address is your delivery address?</span> -->
    </div>
    <div *ngIf="!addressOutOfRange && !addressConfirmed && confirmingAddress" class="margin-top-16">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                         animationDuration=".5s"></p-progressSpinner>
    </div>
  </div>

  <div class="margin-top-16" *ngIf="addressConfirmed && invoice.allowStripePayment">
    <app-jobcard-invoices [jobCards]="jobCards"[serviceID]="serviceID" [partnerID]="partnerID" (update)="reloadDelivery($event)" [showHeader]="false">
    </app-jobcard-invoices>
  </div>

  <!-- <div class="container center-container white-container margin-top-16" *ngIf="dropOff">
    <button pButton type="button" (click)="cancelDropOff()" class="full-width accent" [disabled]="saving || !dropOff"
      label="{{!dropOff ? 'Delivery Cancelled' : 'I will collect later'}}"></button>
  </div> -->

</div>

<div class="container center-container white-container margin-top-16"
     *ngIf="dropOff && ((!allReadyBooked || rescheduleDelivery) && ((invoice.allowStripePayment && invoice.paidWithStripe) || (!invoice.allowStripePayment && addressConfirmed) )) && !loading && !loadingInvoice">

  <div class="complete-payment-header" *ngIf="!multiBikeDelivery">
    {{'cyclist.schedule_delivery' | translate }}
  </div>
  <div class="complete-payment-header" *ngIf="multiBikeDelivery && linkedServices && linkedServices.length > 0">
    {{'cyclist.schedule_delivery_multiple' | translate : {linkedServices: (linkedServices.length + 1)} }}
  </div>

  <div class="bottom-10">
    <h6 [ngClass]="{error:errorDate}">{{'bikeshop.modal.update_job_card.collections.delivery_date' | translate}}</h6>
    <div>
      <p-calendar dateFormat="dd MM yy" [(ngModel)]="deliveryDate" [minDate]="minDate" [selectOtherMonths]="true"
                  [disabledDates]="disabledDates" [readonlyInput]="true" [disabled]="!areaID"
                  (onSelect)="setBookingDate()" (onMonthChange)="monthChanged($event)"></p-calendar>
    </div>
    <div *ngIf="times && times.length> 0 ">
      <div class="scrollmenu">
        <div *ngFor="let timeSlot of times; let i = index">
          <div (click)="selectTime(timeSlot, i)"
               [ngClass]="{selected: selectedTimeSlot && timeSlot.value===selectedTimeSlot.value}" class="timeButton">
            {{timeSlot.label}}
          </div>
        </div>
      </div>
      <div *ngIf="errorTime && !selectedTimeSlot" class="error">{{'cyclist.select_time_slot' | translate}}</div>
    </div>
  </div>
  <div class="bottom-10">
    <h6 [ngClass]="{error:errorAddress}">{{'bikeshop.shop_profile.address' | translate}}</h6>
    <p-autoComplete [(ngModel)]="address.address" [suggestions]="addressOptions" (completeMethod)="search($event)"
                    [disabled]="true" (onSelect)="onSelect($event)" auto-complete='new-password'></p-autoComplete>
  </div>
  <h6 [ngClass]="{error:errorContactDetails}">{{'bikeshop.collections.contact_details' | translate}}</h6>
  <input type="text" pInputText [(ngModel)]="contactDetails" class="bottom-10"/>
  <h6>{{'cyclist.delivery_instructions' | translate}}</h6>
  <input type="text" pInputText [(ngModel)]="dropOffInstructions"/>


  <div class="margin-top-16">
    <button pButton type="button" (click)="Book()" class="full-width" [disabled]="saving"
            label="{{'cyclist.schedule_delivery' | translate }}"></button>
  </div>
  <div class="margin-top-16">
    <!--  todo(dccorbett) no element  *ngIf="!dropoff"  -->
    <button pButton type="button" (click)="cancelDropOff()" class="full-width accent" [disabled]="saving || !dropOff"

            label="{{'cyclist.delivery_cancelled' | translate}}"></button>
    <!--    <button pButton type="button" (click)="cancelDropOff()" class="full-width accent" [disabled]="saving || !dropOff"-->

    <!--            label="{{'cyclist.i_will_collect' | translate }}"></button>-->
  </div>

</div>

<div *ngIf="dropOff && allReadyBooked && !loading && !loadingInvoice && !rescheduleDelivery">
  <div class="container center-container white-container">
    <div class="success-message" *ngIf="!(multiBikeDelivery && linkedServices && linkedServices.length > 0)"
         [innerHTML]="'cyclist.delivery_confirmation' | translate : { date: (deliveryDate | date), time: dropOffTime }"></div>
    <div class="success-message" *ngIf="multiBikeDelivery && linkedServices && linkedServices.length > 0"
         [innerHTML]="'cyclist.delivery_confirmation_multiple' | translate : { date: (deliveryDate | date), time: dropOffTime }"></div>
    <div class="margin-top-16">
      <button pButton type="button" (click)="cancelDropOff()" class="full-width accent"
              [disabled]="saving || jobCard === null || (jobCard && jobCard.invoice && jobCard.invoice.paidWithStripe)"
              label="{{'cyclist.cancel_delivery' | translate}}"></button>
    </div>
    <div class="margin-top-16">
      <button pButton type="button" (click)="rescheduleDropOff()" class="full-width"
              [disabled]="saving || jobCard === null || (jobCard && jobCard.invoice && jobCard.invoice.paidWithStripe)"
              label="{{'cyclist.reschedule_delivery' | translate}}"></button>
    </div>
  </div>
  <div class="margin-top-16">
    <app-jobcard-invoices [jobCards]="jobCards"[serviceID]="serviceID" [partnerID]="partnerID" (update)="updateJobCard($event)"></app-jobcard-invoices>
  </div>
</div>


<div *ngIf="!dropOff && !loading">
  <div class="container center-container white-container">
    <div class="complete-payment-header">
      {{'cyclist.delivery_cancelled' | translate}}
    </div>
    <div class="delivery-cancelled">{{'cyclist.delivery_cancelled_ready_to_collect' | translate}}</div>

    <div class="margin-top-16">
      <button pButton type="button" (click)="rescheduleCancelledDropOff()" class="full-width"
              [disabled]="saving || jobCard === null || (jobCard && jobCard.invoice && jobCard.invoice.paidWithStripe)"
              label="{{'cyclist.schedule_delivery' | translate}}"></button>
    </div>

  </div>

  <div class="margin-top-16">
    <app-jobcard-invoices [jobCards]="jobCards"[serviceID]="serviceID" [partnerID]="partnerID" (update)="updateJobCard($event)"></app-jobcard-invoices>
  </div>
</div>
<p-confirmDialog key="cancel_delivery" global="false" appendTo='body'></p-confirmDialog>
